import { CustomersController } from "@/shared/endpoints/customers";

export const uploadInsurance = (frontFile: File, backFile: File) => {
    const formData = new FormData();

    formData.append('front', frontFile);
    formData.append('back', backFile);
    formData.append('frontContentType', frontFile.type);
    formData.append('backContentType', backFile.type);

    return CustomersController.insuranceUpload(formData);
};

export const uploadSignature = (signatureFile: File) => {
    const formData = new FormData();

    formData.append('file', signatureFile);
    formData.append('contentType', signatureFile.type);

    return CustomersController.signatureUpload(formData);
};